module.exports = __webpack_public_path__ + "img/investpr.4e15c2df.png";